module.exports = __webpack_public_path__ + "static/media/height.a9c62667.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/height.svg
// module id = 606
// module chunks = 0